import React from 'react';
import { Linkedin, Facebook, Mail, Whatsapp } from 'react-social-sharing';

const SocialSharing = () => (
  <div className="social-sharing">
    <p>Share</p>
    <Linkedin simple link={window.location.href} />
    <Facebook simple link={window.location.href} />
    <a
      href={`https://x.com/intent/tweet/?text=&url=${window.location.href}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-k200y r-18jsvk2 r-5sfk15 r-kzbkwu"
        height="20"
        width="20"
      >
        <g>
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
        </g>
      </svg>
    </a>
    <Whatsapp simple link={window.location.href} />
    <Mail simple solidcircle link={window.location.href} />
  </div>
);

export default SocialSharing;
